import { FORM_ID } from "../../../../../constants/Forms";
import ReviewSignSectionHeader from "./ReviewSignSectionHeader";

function ReviewPersonalInfo(props) {
  const toggleForm = () => {
    props.toggleForm(FORM_ID.PERSONAL_INFO);
  };
  return (
    <div id="psnl-info">
      <ReviewSignSectionHeader
        toggleForm={toggleForm}
        id={"pi"}
        headerText="Personal Information"
      ></ReviewSignSectionHeader>
      <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-12" id="frst-name">
          <h5>Legal First Name</h5>
        </div>
        <div id="firstname" className="col-lg-3 col-md-6 col-sm-12 data">
          {props.personalInformation.firstname}
        </div>
        {props.personalInformation.middlename !== "" && (
          <>
            <div className="col-lg-3 col-md-6 col-sm-12" id="middle-name">
              <h5>Middle Name</h5>
            </div>
            <div id="middlename" className="col-lg-3 col-md-6 col-sm-12 data">
              {props.personalInformation.middlename}
            </div>
          </>
        )}

        <div className="col-lg-3 col-md-6 col-sm-12" id="lst-name">
          <h5>Legal Last Name</h5>
        </div>
        <div id="lastname" className="col-lg-3 col-md-6 col-sm-12 data">
          {props.personalInformation.lastname}
        </div>

        {props.personalInformation.suffix !== "" && (
          <>
            <div className="col-lg-3 col-md-6 col-sm-12" id="suffx">
              <h5>Suffix</h5>
            </div>
            <div id="suffix" className="col-lg-3 col-md-6 col-sm-12 data">
              {props.personalInformation.suffix}
            </div>
          </>
        )}

        {props.personalInformation.preferredfirstname !== "" &&
          props.personalInformation.preferredfirstname !== null && (
            <>
              <>
                <div
                  className="col-lg-3 col-md-6 col-sm-12"
                  id="prfrred-fst-nme"
                >
                  <h5>Preferred First Name</h5>
                </div>
                <div
                  id="preferredfirstname"
                  className="col-lg-3 col-md-6 col-sm-12 data"
                >
                  {props.personalInformation.preferredfirstname}
                </div>
              </>
              {props.personalInformation.preferredlastname !== "" &&
                props.personalInformation.preferredlastname !== null && (
                  <>
                    <div
                      className="col-lg-3 col-md-6 col-sm-12"
                      id="prferrd-lst-name"
                    >
                      <h5>Preferred Last Name</h5>
                    </div>
                    <div
                      id="preferredlastname"
                      className="col-lg-3 col-md-6 col-sm-12 data"
                    >
                      <>{props.personalInformation.preferredlastname}</>
                    </div>
                  </>
                )}
            </>
          )}
        <>
          <div className="col-lg-3 col-md-6 col-sm-12" id="ssn-no">
            <h5>Social Security Number</h5>
          </div>
          <div id="ssn" className="col-lg-3 col-md-6 col-sm-12 data">
            {props.candidatePresentationMode
              ? `XXX-XX-${props.personalInformation.ssn.slice(-4)}`
              : props.personalInformation.ssn}
          </div>
        </>
        <>
          <div className="col-lg-3 col-md-6 col-sm-12" id="d-o-b">
            <h5>Date of Birth</h5>
          </div>
          <div id="dateofbirth" className="col-lg-3 col-md-6 col-sm-12 data">
            {props.personalInformation.dateofbirth}
          </div>
        </>
        <>
          <div className="col-lg-3 col-md-6 col-sm-12" id="gndr">
            <h5>Gender</h5>
          </div>
          <div id="gender" className="col-lg-3 col-md-6 col-sm-12 data">
            {props.personalInformation.genderdesc}
          </div>
        </>
        <>
          <div className="col-lg-3 col-md-6 col-sm-12" id="phn">
            <h5>Phone Number</h5>
          </div>
          <div id="phonenumber" className="col-lg-3 col-md-6 col-sm-12 data">
            {props.personalInformation.phonenumber.slice(-12)}
          </div>
        </>
        <>
          <div className="col-lg-3 col-md-6 col-sm-12" id="eml">
            <h5>Email</h5>
          </div>
          <div id="emailaddress" className="col-lg-3 col-md-6 col-sm-12 data">
            {props.personalInformation.emailaddress}
          </div>
        </>
      </div>
    </div>
  );
}

export default ReviewPersonalInfo;
